export default class ChatModel {
  constructor({
    name,
    last_name,
    id,
    url_photoProfile,
    role,
    createdAt,
    email,
    phone_number,
  }) {
    this.name = name;
    this.last_name = last_name;
    this.id = id;
    this.url_photoProfile = url_photoProfile;
    this.role = role;
    this.createdAt = createdAt;
    this.email = email;
    this.phone_number = phone_number;
  }
}
